import { BordTextButton } from 'bord-design-system';
import { bordColorTheme } from 'styles/styles.constants';
import { metabaseUrl } from 'constants/constants';
import './ToolSearchMetabaseRow.scss';

/**
 * Fila de ayuda que invita al usuario a buscar en Metabase con filtros avanzados.
 */
const ToolSearchMetabaseRow = () => (
  <div className="toolSearchMetabaseRow">
    <span className="metabaseHint">
      Usa Metabase para buscar SKUs por modelo, pills y otros filtros de forma más rápida
    </span>
    <BordTextButton
      text="Ir a Metabase"
      onClick={() => window.open(metabaseUrl, '_blank')}
      rightIconProps={{ variant: 'externalLink', standardSize: 12, stroke: bordColorTheme.cyan[400] }}
      className="metabaseLink"
    />
  </div>
);

export default ToolSearchMetabaseRow;
